import { render, staticRenderFns } from "./ProfilePhoto-Profile.vue?vue&type=template&id=461f97c2&"
import script from "./ProfilePhoto-Profile.vue?vue&type=script&lang=js&"
export * from "./ProfilePhoto-Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports